import { useEffect, useState } from "react";

/**
 * A small stationary brand mark pinned to the viewport's hill line.
 * It fades in only when the user is near the bottom of the page so it never
 * covers the content mid-scroll but still feels like a warm signature
 * standing on the path.
 */
export default function BrandBand() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show once the user is within 480px of the bottom of the document.
      const scrolledFromBottom =
        document.documentElement.scrollHeight -
        window.innerHeight -
        window.scrollY;
      setVisible(scrolledFromBottom < 480);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className="pointer-events-none select-none"
      aria-hidden="true"
      data-testid="brand-band"
      style={{
        position: "fixed",
        left: "50%",
        bottom: "32vh",
        transform: "translateX(-50%)",
        zIndex: 5,
        opacity: visible ? 1 : 0,
        transition: "opacity 400ms ease-out",
      }}
    >
      <img
        src="/brand/logo-full.png"
        alt=""
        className="w-[min(280px,52vw)] h-auto"
        style={{ filter: "drop-shadow(0 8px 18px rgba(45,48,85,0.2))" }}
        draggable="false"
      />
    </div>
  );
}
